import { UserService } from 'src/app/core/service/user.service';
import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { RegistrationService } from '../service/registration.service';

@Injectable({
  providedIn: 'root'
})
export class UserValidators
{
  public selectedUser: any;

  constructor(
    private registrationService: RegistrationService,
    private userService: UserService)
  {
  }

  public validateUsernameUnique(control: UntypedFormControl): any
  {
    return new Promise(resolve =>
    {
      this.registrationService.usernameExists(control.value).subscribe({
        next: (response) =>
        {
          if (response)
          {
            resolve({ usernameTaken: true });
          }
          else
          {
            resolve(null);
          }
        }
      });
    });
  }

  public validateEmailUnique(control: UntypedFormControl): any
  {
    return new Promise(resolve =>
    {
      if (control !== null && this.selectedUser.email !== control.value)
      {
        this.registrationService.emailExists(control.value).subscribe({
          next: (response) =>
          {
            if (response)
            {
              resolve({ emailTaken: true });
            }
            else
            {
              resolve(null);
            }
          }
        });
      }
      else
      {
        resolve(null);
      }
    });
  }

  public validateDirectAddressUnique(control: UntypedFormControl): any
  {
    return new Promise(resolve =>
    {
      if (control !== null && this.selectedUser.directAddress !== control.value)
      {
        this.userService.directAddressExists(control.value).subscribe({
          next: (response) =>
          {
            if (response)
            {
              resolve({ directAddressTaken: true });
            }
            else
            {
              resolve(null);
            }
          }
        });
      }
      else
      {
        resolve(null);
      }
    });
  }
}
